import React, { lazy } from 'react';
import style from './footer.module.scss';
import { routesInMenu } from 'constants/routesInMenu';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectors } from 'utils/reduxSelector';
import { IS_NATIVE_APP } from 'utils/native';

const LazyAppPromoter = lazy(() => import('./components/appPromoter'));

const Footer: React.FC = () => {
  const isMobileScreen = useSelector(selectors.mobileSelector.isMobileScreen);
  return (
    <div className={style.container}>
      {!IS_NATIVE_APP && <LazyAppPromoter />}
      <div className={`${style.info} ${!IS_NATIVE_APP ? 'mt-3' : ''}`}>
        <p>
          Danea Interventi è un servizio di{' '}
          <a className={style.link} href="https://www.teamsystem.com/" target="_blank" rel="noopener noreferrer">
            TeamSystem S.p.A
          </a>
          {isMobileScreen ? '' : '- P.I. 01035310414'}
        </p>
        <div className="d-sm-flex justify-content-center align-items-center my-sm-1">
          {isMobileScreen && <p>P.I. 01035310414</p>}
          {isMobileScreen && <p className="mx-2">|</p>}
          <Link to={routesInMenu.privacyPolicy} className={style.link}>
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Footer;
